import { writable } from 'svelte/store';

export const store = writable({
    locale: 'en',
    wpVersion: '3.1',
    targetWidth: null,
    imageWidth: null,
    imageHeight: null,
    type: 'mo',
    r: 1,
    isDev: false,
    showColor: false,
    showGrabber: false,
    showMover: false,
    
});

export const address = writable('');

export const isHackActive = writable(false);

export const nextHackIndex = writable(-1);

export const hackCuts = writable({
    c1: -1,
    c2: -1,
    c3: -1,
})

export const mysteryItems = writable([
    {
        name: 'KCT 티셔츠',        
        quantity: 100,
        image: '/images/kbw/kct.png',
    },
    {
        name: 'Chopard 향수',        
        quantity: 300,
        image: '/images/kbw/chopard.png',
    },
    {
        name: '헤드스파7 노워시샴푸',        
        quantity: 100,
        image: '/images/kbw/headspa.png',
    },
    {
        name: '구찌 선글라스',        
        quantity: 5,
        image: '/images/kbw/gucci.png',
    },
    {
        name: 'OB 맥주 세트',        
        quantity: 50,
        image: '/images/kbw/ob.png',
    },
    {
        name: '매머드커피 상품권',        
        quantity: 100,
        image: '/images/kbw/mammoth.png',
    },
    {
        name: '에이든호텔 숙박권',        
        quantity: 5,
        image: '/images/kbw/aiden.png',
    },
    {
        name: '멜팅소울 햄버거 식사권',        
        quantity: 5,
        image: '/images/kbw/meltingsoul.png',
    },
    {
        name: '조말론 향수',        
        quantity: 3,
        image: '/images/kbw/jomalone.png',
    },
    {
        name: '불가리 향수',        
        quantity: 2,
        image: '/images/kbw/bvlgari.png',
    },
    {
        name: '바아레도 향수',        
        quantity: 1,
        image: '/images/kbw/byredo.png',
    },
    {
        name: 'TS 샴푸린스세트',        
        quantity: 50,
        image: '/images/kbw/ts.png',
    }
]);

export const raumItems = writable([
    {
        name: 'bottleshock 와인',        
        quantity: 1,
        image: '/images/raum/bottleshock.png',
    },
    {
        name: 'world 와인',        
        quantity: 0,
        image: '/images/raum/world.png',
    },
    {
        name: 'allvintage 와인',        
        quantity: 1,
        image: '/images/raum/allvintage.png',
    },
    {
        name: 'curious 와인',        
        quantity: 1,
        image: '/images/raum/curious.png',
    },
    {
        name: 'czar 와인',        
        quantity: 1,
        image: '/images/raum/czar.png',
    },
    {
        name: 'dongwon 와인',        
        quantity: 2,
        image: '/images/raum/dongwon.png',
    },
    {
        name: 'nuruk 와인',        
        quantity: 0,
        image: '/images/raum/nuruk.png',
    },
    {
        name: 'armani 립스틱',        
        quantity: 5,
        image: '/images/raum/armani.png',
    },
    {
        name: 'diptyque 향수',        
        quantity: 0,
        image: '/images/raum/diptyque.png',
    },
    {
        name: 'gucci 선글라스',        
        quantity: 4,
        image: '/images/raum/gucci.png',
    },
    {
        name: 'jomalone 크림',        
        quantity: 3,
        image: '/images/raum/jomalone.png',
    },
    {
        name: 'ysl 카드지갑',        
        quantity: 1,
        image: '/images/raum/ysl.png',
    },
    {
        name: 'ts 샴푸세트',        
        quantity: 8,
        image: '/images/raum/ts.png',
    },
    {
        name: 'kct 티셔츠',        
        quantity: 2,
        image: '/images/raum/kct.png',
    },
    {
        name: 'lelabo 향수',        
        quantity: 2,
        image: '/images/raum/lelabo.png',
    },
    {
        name: 'bvlgari 향수',        
        quantity: 0,
        image: '/images/raum/bvlgari.png',
    },
    {
        name: 'Dior 헤어미스트',        
        quantity: 0,
        image: '/images/raum/dior.png',
    },
    {
        name: 'jomalone 향수',        
        quantity: 0,
        image: '/images/raum/jomalone2.png',
    },
    {
        name: 'ysl 립스틱',        
        quantity: 4,
        image: '/images/raum/ysl2.png',
    }
]);